module.exports = "#include <common>\n\nattribute float random;\n\nvarying float vRandom;\n// varying vec2 vUv;\n\nuniform float size;\nuniform float scale;\n\nvoid main() {\n  // vUv = uv;\n  vRandom = random;\n\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n\n  vec3 transformed = vec3(position);\n  vec4 mvPosition = modelViewMatrix * vec4(transformed, 1.0);\n  gl_PointSize = (0.75 + random * 0.75) * size * (scale / -mvPosition.z);\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/SpiralField/points-shader/vertex.vert
// module id = 344
// module chunks = 0